import React from "react"

const t = (string, options) => {
  return window.slideshare_object.utils.i18n(string, options)
}

export const Translation = ({ string, options = {} }) => {
  const translated = t(string, options)
  return <span dangerouslySetInnerHTML={{ __html: translated }} />
}

export default t
